module.exports = __webpack_public_path__ + "assets/img/donation-flow-thank-you@2x.6f70000a.png";